import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/utils';

const toggleVariants = cva(
  [
    'inline-flex items-center justify-center rounded-button text-body-m-regular ring-offset-fill-background-neutral transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-text-default-primary focus-visible:ring-offset-2 gap-2',
    'bg-transparent hover:bg-fill-hover border border-transparent',
    'data-[state=on]:bg-fill-accent data-[state=on]:hover:bg-fill-accent/80 data-[state=on]:border data-[state=on]:border-text-brand-primary data-[state=on]:text-text-brand-primary',
    'disabled:pointer-events-none disabled:bg-fill-hover disabled:text-text-default-secondary [&_svg]:disabled:stroke-text-default-secondary',
  ],
  {
    variants: {
      size: {
        M: 'px-4 py-2.5 [&_svg]:size-4',
        L: 'px-4 py-3 [&_svg]:size-6',
        iconM: 'p-3 [&_svg]:size-4',
        iconL: 'p-3 [&_svg]:size-6',
      },
      variant: {
        default: '',
        outline: 'border border-outline-input-default hover:border-outline-input-hover',
      },
    },
    defaultVariants: {
      size: 'M',
      variant: 'default',
    },
  },
);

const Toggle = ({ className, size, variant, ...props }: React.ComponentPropsWithRef<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) => (
  <TogglePrimitive.Root className={cn(toggleVariants({ size, variant, className }))} {...props} />
);

// eslint-disable-next-line react-refresh/only-export-components
export { Toggle, toggleVariants };
